import React from 'react';
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faTimes } from '@fortawesome/free-solid-svg-icons';

const SupportClowzaModal = ({ show, onHide }) => {
  const handleDonateNGN = () => {
    window.open('https://paystack.shop/pay/clowza-ngn', '_blank');
  };

  const handleDonateUSD = () => {
    window.open('https://paystack.shop/pay/clowza-usd', '_blank');
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered
      className="support-clowza-modal"
    >
      <Modal.Body className="text-center px-4 pb-4 pt-4 position-relative">
        {/* Close button at top right */}
        <button
          onClick={onHide}
          className="support-modal-close-btn"
          aria-label="Close"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>

        {/* Heart icon */}
        <div className="support-heart-icon mb-3">
          <FontAwesomeIcon icon={faHeart} />
        </div>

        {/* Title */}
        <h4 className="mb-4">Support Clowza</h4>

        {/* Message */}
        <p className="support-message mb-4">
          Your support means the world to us! Every contribution helps fund further development, 
          upgrades, new features, and operational costs that keep Clowza running smoothly.
        </p>
        <p className="support-submessage mb-4 text-muted">
          Together, we can continue building a platform that connects believers and strengthens 
          the community of faith.
        </p>

        {/* Donation buttons */}
        <div className="d-flex flex-column gap-3">
          <button 
            className="btn btn-success btn-lg support-donate-btn"
            onClick={handleDonateNGN}
            style={{
              background: 'linear-gradient(135deg, #48887b 0%, #3a6d62 100%)',
              border: 'none',
              borderRadius: '8px',
              padding: '12px 24px',
              fontWeight: '600',
              boxShadow: '0 4px 12px rgba(72, 136, 123, 0.3)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 16px rgba(72, 136, 123, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(72, 136, 123, 0.3)';
            }}
          >
            Donate in NGN
          </button>
          <button 
            className="btn btn-primary btn-lg support-donate-btn"
            onClick={handleDonateUSD}
            style={{
              background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
              border: 'none',
              borderRadius: '8px',
              padding: '12px 24px',
              fontWeight: '600',
              boxShadow: '0 4px 12px rgba(0, 123, 255, 0.3)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 16px rgba(0, 123, 255, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(0, 123, 255, 0.3)';
            }}
          >
            Donate in USD
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SupportClowzaModal;
